import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { ModalType } from '../Content/MarketingCopy';

export interface ModalHeaderProps {
  disclosure?: string;
  highlight?: string;
  modalType?: ModalType;
  subtitle: string;
  title: string;
}

const ModalHeader = ({ highlight, title, subtitle, disclosure, modalType }: ModalHeaderProps) => {
  return (
    <header className="mb-16 flex w-full flex-col text-left sm:mb-32 md:mb-0 md:w-1/2">
      {highlight && (
        <span className="font-suisse-intl text-overline-lg text-primary-magenta">{highlight}</span>
      )}
      <h1 className="mb-8 mt-0 font-suisse-works text-headline-md text-white sm:text-headline-lg md:text-headline-xl">
        {title}
      </h1>
      <p className="my-0 font-suisse-intl-mono text-overline-lg text-white">
        {ReactHtmlParser(subtitle)}
      </p>
      {disclosure && modalType === ModalType.LeadCapture && (
        <p className="mb-0 mt-8 text-left font-suisse-screen text-disclosure-sm text-white">
          {disclosure}
        </p>
      )}
    </header>
  );
};

export default ModalHeader;
